import { IIntegration, IntegrationType } from '@principle-theorem/integrations';
import {
  DocumentReference,
  TypeGuard,
  isDocRef,
} from '@principle-theorem/shared';
import { isString, isUndefined } from 'lodash';
import { IPractice } from '../practice/practice';
import { IBaseSMSIntegrationData } from './sms-integration';

export function isTwilioIntegration(
  item: IIntegration
): item is IIntegration<ITwilioIntegrationData> {
  return item.type === IntegrationType.Twilio;
}

export interface ITwilioPracticeNumber {
  phoneNumber: string;
  practiceRef: DocumentReference<IPractice>;
  disabled?: boolean;
}

export function isTwilioPracticeNumber(
  item: unknown
): item is ITwilioPracticeNumber {
  return TypeGuard.interface<ITwilioPracticeNumber>({
    phoneNumber: isString,
    practiceRef: isDocRef,
    disabled: [isString, isUndefined],
  })(item);
}

export interface ITwilioConfig extends IBaseSMSIntegrationData {
  authToken?: string;
  accountSid?: string;
  phoneNumbers?: ITwilioPracticeNumber[];
}

export interface ITwilioIntegrationData extends ITwilioConfig {
  enabled: boolean;
  testModeEnabled: boolean;
}
